import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PRODUCTS_SEARCH_QUERY_KEY} from "../queryKeys";

type Variables = {q: string};
type Data = string[];

const searchProducts = async (variables: Variables): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/segments/products", {
    params: {q: variables.q},
  });
  return response.data;
};

export const useSearchProducts = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>([PRODUCTS_SEARCH_QUERY_KEY, variables.q], searchProducts, variables, options);
